const {coordinate} = require('./timesheetCellSelection');
const {summarizeDays, formatCipher, dayColumns, orderedKeys, normalizeCode} = require('./timesheetDaySummary');

function selectionSummary(api, keys) {
    const sheet = api.sheet || {}, bootstrap = api.bootstrapData || {};
    const policy = (api.canEdit ? (bootstrap.policy || {}).day_counting : sheet.selection_day_counting)
        || (bootstrap.policy || {}).day_counting || {};
    const codes = sheet.codes || bootstrap.codes || [];
    const codeById = new Map(codes.map(code => [Number(code.id), code.code]));
    const lines = new Map((sheet.lines || []).map(line => [String(line.id), line]));
    const records = [], invalid = [];
    let external = 0;
    const selected = Array.from(new Set(keys));
    selected.forEach(key => {
        const {lineId, date} = coordinate(key), line = lines.get(lineId);
        if (!line) { invalid.push(key); return; }
        if (api.hasExternalEntry && api.hasExternalEntry(line, date)) external++;
        try {
            let value;
            if (api.canEdit && Object.prototype.hasOwnProperty.call(api.monthCellDrafts || {}, key)) {
                const parsed = api.parseMonthCell(api.monthCellDrafts[key]);
                value = {worked_minutes: parsed.worked_minutes, codes: [parsed.absence_code, parsed.travel_code].filter(Boolean)};
            } else {
                const entry = api.entryFor ? api.entryFor(line, date) : (line.entries || []).find(item => String(item.work_date).slice(0, 10) === date);
                value = {worked_minutes: entry ? Number(entry.worked_minutes || 0) : 0,
                    codes: entry ? [entry.absence_code_id, entry.travel_code_id].filter(Boolean).map(id => {
                        if (!codeById.has(Number(id))) throw Error('Unknown code');
                        return codeById.get(Number(id));
                    }) : []};
            }
            if (!Number.isFinite(value.worked_minutes) || value.worked_minutes < 0) throw Error('Invalid hours');
            records.push({...value, key: `${lineId}:${date}`, policy});
        } catch (error) { invalid.push(key); }
    });
    return summarizeSelection(records, selected.length, invalid, external, codes);
}

function summarizeSelection(records, count, invalid = [], external = 0, codes = []) {
    const result = summarizeDays(records);
    const labels = new Map(dayColumns.map(column => [column.key, column.label]));
    codes.forEach(code => { if (code.name) labels.set(normalizeCode(code.code), `${code.name} (${code.code})`); });
    return {...result, count, invalid, external, cipher: formatCipher(result.totals),
        details: orderedKeys(result.totals).filter(key => key === 'worked' || result.totals[key])
            .map(key => ({key, label: labels.get(key) || key, value: result.totals[key]}))};
}
module.exports = {selectionSummary, summarizeSelection};
